import Vue from "vue";
export default {
  GET_USER(state, payload) {
    state.user = payload;
  },
  GET_ALL(state, payload) {
    state.get_AllBooking = payload;
  },
  DELETE_Booking(state, payload) {
    const index = state.get_AllBooking.findIndex(
      (page) => page._id === payload._id
    );
    state.get_AllBooking.splice(index, 1);
  },
  SELECT_Booking(state, payload) {
    state.selectBooking = payload;
  },
};
